//Import created components
import Eleve from '../../components/eleve/Eleve.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getEleves, getSelectedCreneaux, getFormulesEleves, getResa } from "../../store/selectors.js";
import { elevesSlice } from "../../store/elevesSlice.js";
import { selectedCreneauxSlice } from "../../store/selectedCreneauxSlice.js";


//Import React Hooks
import { useEffect, useState } from 'react'

//import MUI
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

//Utils 
import convertHoraire from '../../utils/convert_horaire.js';
import elevesSorter from '../../utils/eleves_sorter.js';
import filterCreneaux from '../../utils/filterCreneaux.js';

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function CreneauPopover({ creneau, setAnchorEl, mode, eleve }) {
    //// -  !!! prop "mode" = "creneau", or "ajout" or "modif"
    //// - mode is used to managed different displays

    let [creneaux, setCreneaux] = useState([]);
    let [creneauxResa, setCreneauxResa] = useState([]);
    let [currentDate, setCurrentDate] = useState(creneau.date);
    let allResaInfos = useSelector(getResa);
    const lang = useSelector(getLang) //global state : language
    let wallyEditor = false;

    useEffect(() => { // at first render
        if (mode === "ajout") { // if adding new creneau from scratch...
            handleChangeDate(dayjs()); // ... set datepicker with today's date
            setRiderList([{ id: eleve.id }]); // ...we init the list of checked riders with the only of selected line (Eleve compoenet)
        }
        else {
            handleChangeDate(dayjs(creneau.date));
            setCurrentTime(creneau.horaire);
        }
        async function initCreneauxResa() {
            let crenrez = [];
            if (allResaInfos.CreneauEleves) {
                crenrez = await getCreneauxResa(allResaInfos.id_resa);
            }
            setCreneauxResa(crenrez);

        }

        initCreneauxResa(); //call the inner asnchrone function

    }, [creneau])


    useEffect(() => { // when day from datepicker changes, (mode ajout or modif) 
        if (dayjs(currentDate).isSame(dayjs(creneau.date))) { // if same day as original creneau date
            setCurrentTime(creneau.horaire) //we init the select with original creneau start
        }
        else {
            if (creneaux.length > 0) { setCurrentTime(creneaux[0].horaire) }; // we init the hours select with first horaire of the selected day
        }
    }, [creneaux])

    async function getCreneauxResa(idResa) { //jour : date as string

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/creneau-eleve/resa/${idResa}`,
            });
            //console.log(response);
            const crens = response.data.data;
            return crens;
        } catch (err) {
            console.error(err);
            return null;
        }
    }


    let allEleves = useSelector(getEleves);
    let formulesEleves = useSelector(getFormulesEleves);
    // if editResa Mode :

    let modifMode = false;
    if (allResaInfos.CreneauEleves) {
        modifMode = allResaInfos.CreneauEleves.length > 0;
        wallyEditor = (allResaInfos.nb_modifs % 2 === 0);
    }

    let selectedEleves = allEleves.filter((eleve) => eleve.checked === true);
    selectedEleves = elevesSorter(selectedEleves);


    let selectedCreneaux = useSelector(getSelectedCreneaux);
    //console.log(selectedCreneaux);
    // find if this current creneau is already selected?
    let currentCreneau = selectedCreneaux.filter((ligne) => ligne.creneau.id_creneau === creneau.id_creneau);
    // if creneau already selected, we get the list of attending eleves, or we set the list empty
    let ridersInit = currentCreneau.length > 0 ? currentCreneau[0].eleves : [];

    let [currentTime, setCurrentTime] = useState(creneau.horaire);
    const [riderList, setRiderList] = useState(ridersInit); // we init the list of riders to be checked for this creneau, the ones who attend
    const dispatch = useDispatch();


    function handleClose() { // close popover
        setAnchorEl(null);
    }

    function handleDelete() { // when click on "supprimer" button (mode "modif" only):

        let newList = riderList.filter((rider) => rider.id != eleve.id); //we remove the "current" eleve from the list of eleve for this creneau

        if (newList.length === 0) { // if no eleve left after this removal...
            // we delete the whole creneau from selcted creneaux
            dispatch(selectedCreneauxSlice.actions.removeCreneau(creneau.id_creneau));
        }
        else { //if other eleves left in the cureent creneau...
            // we just modify the list of eleves attending this creneaux
            dispatch(selectedCreneauxSlice.actions.modifyCreneau({ creneau, eleves: newList }));
        }

        setAnchorEl(null); // close the popover
    }

    function handleConfirm() { // click on ok button

        if (mode === "creneau") { // when popover is open on clicking on one of the creneau in the calendar

            if (modifMode === true) { //modif mode : (editResa page)

                // on ajoute les élèves au creneau choisi
                let newCreneau = selectedCreneaux.filter((session) => session.creneau.horaire === currentTime && dayjs(session.creneau.date).isSame(dayjs(currentDate)))

                if (newCreneau.length === 0) {// si le creneau voulu n'est pas déjà selected, créer créneau
                    let monCreneau = creneaux.filter((session) => session.horaire === currentTime && dayjs(session.date).isSame(dayjs(currentDate)));

                    dispatch(selectedCreneauxSlice.actions.addCreneau({ creneau: monCreneau[0], eleves: riderList }));
                    dispatch(selectedCreneauxSlice.actions.removeCreneau(creneau.id_creneau));
                }
                else {// sinon on le modifie
                    let newRiderList = [];
                    let stayRiderList = [];

                    riderList.map((rider) => {
                        let occurence = newCreneau[0].eleves.filter((eleve) => eleve.id === rider.id); //fin which eleve is already attending the target crebnneau
                        if (occurence.length > 0) { //eleve already attending target creneau
                            stayRiderList.push(rider);
                        }
                        else {
                            newRiderList.push(rider);
                        }
                    }); //end of map

                    console.log(newRiderList, stayRiderList)

                    // let newCreneau = selectedCreneaux.filter((session) => session.creneau.horaire === currentTime && dayjs(session.creneau.date).isSame(dayjs(currentDate)))
                    console.log(newCreneau[0], creneau)
                    //1 :update target creneaux
                    dispatch(selectedCreneauxSlice.actions.modifyCreneau({ creneau: newCreneau[0].creneau, eleves: newCreneau[0].eleves.concat(newRiderList) }));
                    // 2 : update origin creneau
                    if (stayRiderList.length > 0) { // if some rider remaining
                        console.log("update creneau ,nb riders:", stayRiderList.length)
                        dispatch(selectedCreneauxSlice.actions.modifyCreneau({ creneau: creneau, eleves: stayRiderList }));
                    }
                    else { //no more rider remaining...
                        //we delete this creneau
                        console.log("delete origin creneau")
                        dispatch(selectedCreneauxSlice.actions.removeCreneau(creneau.id_creneau));
                    }




                }


            }
            else { //basic editing

                if (riderList.length === 0) { // if no eleve checked ...
                    //... we remove this creneau
                    dispatch(selectedCreneauxSlice.actions.removeCreneau(creneau.id_creneau));

                }

                else { // if some eleve checked?

                    if (currentCreneau.length > 0) { // if this creneau already selected...
                        // we modify the list of eleves for this creneau (in the global state redux)
                        dispatch(selectedCreneauxSlice.actions.modifyCreneau({ creneau, eleves: riderList }));
                    }
                    else { // if this creneau not selected yet
                        // we add(create) this creneau to the list of selected creneaux  (in the global state redux)
                        dispatch(selectedCreneauxSlice.actions.addCreneau({ creneau, eleves: riderList }));
                    }
                }
            } //end of modif mode?
        } // end if mode=creneau

        if (mode === "modif") { // click on one of the EleveSession componenent

            // si m^me creneau, même date, on fait rien
            let memeJour = dayjs(creneau.date).isSame(dayjs(currentDate));
            let memeHeure = creneau.horaire === currentTime;

            if (memeHeure && memeJour) { // meme jour et même heure pour le même élève...
                //aucune modif du coup
                console.log("meme creneau");
            }
            //sinon,
            else {
                //on commence par enlever l'eleve du creneau courant
                let newList = riderList.filter((rider) => rider.id != eleve.id);
                if (newList.length === 0) {
                    // si c'est le seul élève sur ce creneau, on suppr le creneau
                    dispatch(selectedCreneauxSlice.actions.removeCreneau(creneau.id_creneau));
                }
                else {
                    //sinon, on le ritire juste de la liste d'élèves
                    dispatch(selectedCreneauxSlice.actions.modifyCreneau({ creneau, eleves: newList }));
                }

                // on ajoute l'élève au creneau choisi
                let newCreneau = selectedCreneaux.filter((session) => session.creneau.horaire === currentTime && dayjs(session.creneau.date).isSame(dayjs(currentDate)))

                if (newCreneau.length === 0) {// si le creneau voulu n'est pas déjà selected, créer créneau
                    let monCreneau = creneaux.filter((session) => session.horaire === currentTime && dayjs(session.date).isSame(dayjs(currentDate)));
                    dispatch(selectedCreneauxSlice.actions.addCreneau({ creneau: monCreneau[0], eleves: [{ id: eleve.id }] }));

                }
                else {// sinon on le modifie
                    //ATTN : que faire si l'lélève est déjà présent sur le créneau?
                    //on cherche l'élève dans le nouveau creneau : 
                    let monRider = newCreneau[0].eleves.filter((rider) => rider.id === eleve.id)
                    let modifiedRiders = newCreneau[0].eleves.filter((rider) => rider.id != eleve.id)

                    if (monRider.length === 0) {
                        modifiedRiders.push({ id: eleve.id });
                        dispatch(selectedCreneauxSlice.actions.modifyCreneau({ creneau: newCreneau[0].creneau, eleves: modifiedRiders }));

                    }
                    else { // rider déjà présent
                        console.log("rider déjà présent");
                    }

                }



            } // end if same/ different creneau



        } // end if mode=modif

        if (mode === "ajout") { // on ajoute l'élève au creneau choisi

            // on cherche le creneau choisi dans la liste des selcted creneaux
            let newCreneau = selectedCreneaux.filter((session) => session.creneau.horaire === currentTime && dayjs(session.creneau.date).isSame(dayjs(currentDate)))


            if (newCreneau.length === 0) {// creneau choisi pas encore selected => créer créneau 
                let monCreneau = creneaux.filter((session) => session.horaire === currentTime && dayjs(session.date).isSame(dayjs(currentDate)));
                dispatch(selectedCreneauxSlice.actions.addCreneau({ creneau: monCreneau[0], eleves: riderList }));

            }
            else {// creneau choisi déjà selected => on le modifie
                //ATTN : que faire si l'lélève est déjà présent sur le créneau?
                //on cherche l'élève dans le nouveau creneau : 
                let mesRiders = [];
                let presentRiders = newCreneau[0].eleves;
                riderList.map((individu) => { // loop to search eleve already in the session
                    let found = false;
                    presentRiders.map((rider) => {
                        if (rider.id === individu.id) { found = true; }

                    });
                    found === false && mesRiders.push(individu);


                }); // end of search elelve loop


                if (mesRiders.length > 0) { // if one new eleve at least :
                    let modifiedRiders = presentRiders.concat(mesRiders);
                    dispatch(selectedCreneauxSlice.actions.modifyCreneau({ creneau: newCreneau[0].creneau, eleves: modifiedRiders }));

                }
                else { // rider déjà présent // no new eleve
                    console.log("riders déjà présents");
                }

            }

        } // end if mode=ajout



        setAnchorEl(null); // close popover
    }

    function eleveRide(id) { // manage the display of checked boxes
        let rider = riderList.filter((rider) => rider.id === id);

        return (rider.length > 0);
    }

    function eleveFull(id) { // if an eleve already have 5 sessions, we disable the check
        let present = riderList.filter((rider) => rider.id === id).length > 0;
        let nbSessions = formulesEleves.find((eleve) => eleve.id_eleve === id).nb_cours;
        return (nbSessions === 5 && !present);
    }

    function handleCheck(checked, id) { // manage the check toggle for available eleves

        let otherRiders = riderList.filter((rider) => rider.id != id);
        if (checked) {
            otherRiders.push({ id: id });
        }
        setRiderList(otherRiders);
    }

    async function handleChangeDate(date) {
        let creneauxDuJour = await getCreneaux(dayjs(date).format('YYYY-MM-DD'));
        setCreneaux([].concat(creneauxDuJour.sort(
            (p1, p2) => (p1.horaire < p2.horaire) ? -1 : (p1.horaire > p2.horaire) ? 1 : 0)))

        setCurrentDate(dayjs(date).format('YYYY-MM-DD'));


    }

    async function getCreneaux(jour) { //jour : date as string

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/creneau/${jour}`,
            });
            //console.log(response);
            const crens = response.data;
            return crens;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    function handleChangeTime(event) {
        setCurrentTime(event.target.value);
    }



    function hideDeleteButton() { //manage the hide of button if we are in modif (editResa) mode
        /* let modifMode = false;
        if (allResaInfos.CreneauEleves) { modifMode = allResaInfos.CreneauEleves.length > 0; } */
        return (mode === "modif" && modifMode === false);
    }

    function getIdResa() {
        let idResa = 0;

        if (allResaInfos.CreneauEleves) {
            idResa = allResaInfos.id_resa;
        }
        console.log(idResa);
        return idResa;
    }


    return (

        <div className="creneau-popover">
            <div className="creneau-popover-top">

                {mode === "creneau" && modifMode === false ?
                    <p className="creneau-popover-top-datefixe">{dayjs(creneau.date).format("DD/MM/YYYY")}</p>
                    :
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                        <DatePicker
                            disabled={false}
                            defaultValue={mode === "modif" ? dayjs(creneau.date) : dayjs()}
                            value={dayjs(currentDate) || dayjs()}
                            minDate={dayjs()}
                            size="small"
                            onChange={async (newValue) => await handleChangeDate(newValue)} />
                    </LocalizationProvider>
                }


                {creneaux.length === 0 ?
                    <p>{translator("Pas de session à cette date", lang, "calendarNoSession")}</p>
                    :
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="creneau-popover-top-select"
                        size="small"
                        value={currentTime || 0}
                        label="horaire"
                        disabled={mode === "creneau" && modifMode === false}
                        onChange={handleChangeTime}
                        fullWidth
                    /* onChange={handleChange} */
                    >
                        {
                            filterCreneaux(creneaux, wallyEditor, creneauxResa).map((cren) => (
                                <MenuItem key={cren.horaire} value={cren.horaire}>{convertHoraire(cren.horaire, "horaire")}</MenuItem>
                            ))
                        }

                    </Select>
                }

            </div>
            {
                mode != "modif" && <div className="creneau-popover-eleves">
                    <p>{translator("Elèves :", lang, "calendarEleves")}</p>
                    {selectedEleves.map((eleve) =>
                        <FormControlLabel
                            key={eleve.id}
                            control={<Checkbox />}
                            disabled={eleveFull(eleve.id) || modifMode === true}
                            checked={eleveRide(eleve.id)}
                            label={eleve.prenom}
                            onChange={(event) => handleCheck(event.target.checked, eleve.id)}
                        />
                    )}

                </div>
            }
            <div className="creneau-popover-boutons">
                <Button
                    variant="contained"
                    size="small"
                    disabled={(mode != "creneau" && creneaux.length === 0)}
                    className="creneau-popover-boutons-ok"
                    onClick={_ => handleConfirm()}
                >OK</Button>
                {hideDeleteButton() &&
                    <Button
                        variant="contained"
                        size="small"
                        className="creneau-popover-boutons-delete"
                        onClick={_ => handleDelete()}
                    ><DeleteIcon />{translator("Supprimer", lang, "calendarSuppr")}</Button>
                }

                <Button
                    variant="contained"
                    size="small"
                    className="creneau-popover-boutons-cancel"
                    onClick={_ => handleClose()}
                >{translator("Annuler", lang, "calendarAnnul")}</Button>

            </div>
        </div >
    );
}

export default CreneauPopover;